import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useGenericCadastro } from '@/hooks/useGenericCadastro';
import CadastroList from '@/components/cadastros/CadastroList';
import CadastroModal from '@/components/cadastros/CadastroModal';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';

const GenericCadastroPage = ({ title, description, tableName, columns, fields }) => {
  const { data, loading, add, update, remove } = useGenericCadastro(tableName);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingItem, setEditingItem] = useState(null);

  const handleOpenModal = (item = null) => {
    setEditingItem(item);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setEditingItem(null);
    setIsModalOpen(false);
  };

  const handleSubmit = async (payload) => {
    try {
      if (editingItem) {
        await update(editingItem.id, payload);
      } else {
        await add(payload);
      }
      handleCloseModal();
    } catch (e) {
      // Error is handled by hook
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Tem certeza que deseja remover este registro?')) {
      await remove(id);
    }
  };

  return (
    <div className="container mx-auto py-16 px-4 max-w-6xl">
      <Helmet>
        <title>{title} - Sistema</title>
        <meta name="description" content={`Gerenciamento de ${title.toLowerCase()}`} />
      </Helmet>

      <Card className="rounded-xl shadow-sm border border-gray-100">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-6 bg-gray-50/50 rounded-t-xl">
          <div>
            <CardTitle className="text-2xl font-bold text-[#193D6D]">{title}</CardTitle>
            <CardDescription className="mt-1.5">{description}</CardDescription>
          </div>
          <Button onClick={() => handleOpenModal()} className="bg-[#193D6D] hover:bg-[#193D6D]/90 text-white">
            <Plus className="w-4 h-4 mr-2" />
            Adicionar Novo
          </Button>
        </CardHeader>
        <CardContent className="pt-6">
          <CadastroList
            columns={columns}
            data={data}
            loading={loading}
            onEdit={handleOpenModal}
            onDelete={handleDelete}
          />
        </CardContent>
      </Card>

      <CadastroModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        title={editingItem ? `Editar ${title}` : `Novo ${title}`}
        fields={fields}
        initialData={editingItem}
        onSubmit={handleSubmit}
        loading={loading}
      />
    </div>
  );
};

export default GenericCadastroPage;